import { Popup } from '@dx-ui/osc-popup';
import { GlobalNavMenu } from './global-nav-menu';
import { Link } from '@dx-ui/global-ui-prism';
import { sendInteractionReward } from '../../header.utilities';
import { HEADER_VARIANT_TYPE } from '../../header.constants';
import { HeaderLogo } from '../header-logo';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';

export const DesktopHamburgerNavTrigger = () => {
  const {
    brand,
    visual: { surfaceType, isTranslucent, suppressLogo },
    navigation: {
      globalNavLinks,
      globalNavCustomClassName,
      headerVariantType,
      globalNavLogoSurfaceType,
    },
  } = useHeaderContext();
  const {
    displayFlags: { shouldShowHamburger },
    headingLevelProps,
    styling: { logoVariant },
  } = useHeaderStateContext();

  // For hamburger nav minimal, we don't show logo on top line
  const shouldShowLogoOnTopLine = false;

  return shouldShowHamburger ? (
    <div className="flex min-h-[4.5rem] items-center">
      <Popup key="globalNav">
        <div className="z-10">
          {(headerVariantType === HEADER_VARIANT_TYPE.hamburgerNav ||
            headerVariantType === HEADER_VARIANT_TYPE.hamburgerNavMinimal ||
            headerVariantType === HEADER_VARIANT_TYPE.hamburgerNavMinimalReimagine) && (
            <GlobalNavMenu
              globalNavLinks={globalNavLinks}
              customClassName={globalNavCustomClassName}
              headerVariantType={headerVariantType}
              surfaceType={surfaceType}
              isTranslucent={isTranslucent}
              globalNavLogoSurfaceType={globalNavLogoSurfaceType}
            />
          )}
        </div>
      </Popup>
      {shouldShowLogoOnTopLine ? (
        <div {...headingLevelProps}>
          <Link
            colorTheme="inherit"
            url={brand.url}
            target={brand.target}
            onClick={sendInteractionReward}
            // once nav is implemented on all pages for OHW make w-72 for all brands per UX/UI
            anchorClassName="relative block h-14 w-28 brand-ee:lg:w-44 brand-ej:lg:w-44 brand-ou:lg:w-72 brand-lx:lg:w-72 brand-yh:lg:w-72 me-1"
            showNewWindowIcon={false}
          >
            {!suppressLogo ? <HeaderLogo variant={logoVariant} brand={brand} /> : null}
          </Link>
        </div>
      ) : null}
    </div>
  ) : null;
};
